import { IElementType, IExtendElementType } from "../definitions/element";
import { ISpoolElement } from "../definitions/spools";
import { IProject } from "../store/interface/projects";
import { ListSectionProps } from "../types/sectionTypes";
import { TScopesType } from "../untils/const";

export const projectPropsScope = [
  "projectID",
  "projectName",
  "contractID",
  "contractName",
];

export const sectionPropsScope = ["sectionName", "kks", "fileName","revision"];

export const sectionFormExclude = [
  "file",
  "fileSize",
  "createdTime",
  "updatedTime",
];
export const projectFormExclude = ["createdTime", "updatedTime", "author",'contractName'];

export const getProjectProps = (projectID: string, projects: IProject[]) => {
  const project = projects.find((_project) => _project.projectID === projectID);
  const projectDetails: Record<string, string | number> = {};
  projectPropsScope.forEach((prop) => {
    projectDetails[prop] = project
      ? project[prop as keyof typeof project] || ""
      : "";
  });
  return projectDetails;
};

export const getSectionProps = (
  sectionID: string,
  sections: ListSectionProps[]
) => {
  const section = sections.find((_section) => _section.sectionID === sectionID);
  const sectiontDetails: Record<string, string | number | boolean> = {};
  sectionPropsScope.forEach((prop) => {
    sectiontDetails[prop] = section
      ? section[prop as keyof typeof section] || ""
      : "";
  });
  return sectiontDetails;
};

export const serliazizeProjectsList = (projects: IProject[]) => {
  projects.forEach((_project) => {
    _project.id = _project.projectID || "";
  });
  return projects;
};

export const serliazizeSectionsList = (sections: ListSectionProps[]) => {
  sections.forEach((_section) => {
    _section.id = _section.sectionID || "";
  });
  return sections;
};

export const serializeListSection = (
  points: IElementType[],
  projectID: string,
  projects: IProject[],
  sections: ListSectionProps[],
  spools: ISpoolElement[],
): IExtendElementType[] => {
  const pointsList: IExtendElementType[] = [];
  const projectDetails = getProjectProps(projectID, projects);
 
  points.forEach((_point) => {
    if(_point.spoolID !==''){
    _point.spoolName = spools.find(_spool => _spool.spoolID === _point.spoolID)?.spoolName || ''
  }
    
  const sectionDetails = getSectionProps(_point.sectionID || "", sections);
 
    const newPoint = {
      ..._point,
      ...projectDetails,
      ...sectionDetails,
    };

    pointsList.push(newPoint as IExtendElementType);
  });
  return pointsList;
};

//setter
export const serializeProject = (
  projectState: Record<string, string | number>,
  uid: string
) => {
  const project: Record<string, string | number> = {};
  Object.entries(projectState).forEach(([key, value]) => {
    if (key === "projectName") {
      project[key] = value.toString().trim();
    } else if (key === "contractName") {
      project.contractID = value;
    } else {
      project[key] = value;
    }
  });

  project.createdTime = Date.now();
  project.updatedTime = Date.now();
  project.author = uid || "";

  return project;
};

export const serializeSection = (
  sectionState: Record<string, string | number | undefined | File>,
  orgID: string,
  projectID: string
): FormData => {
  const excludeKeys = ["fileSize"];
  const formData = new FormData();

  Object.entries(sectionState).forEach(([key, value]) => {
    if (!excludeKeys.includes(key) && value !== undefined) {
      formData.append(key, value instanceof File ? value : value.toString());
    }
  });
  formData.append("orgID", orgID);
  formData.append("projectID", projectID);
  formData.append("updatedTime", Date.now().toString());
  formData.append("createdTime", Date.now().toString());
  return formData;
};

export const serializeEditedSection = (sectionState: TScopesType) => {
  const excludseEdited = ["fileSize", "show"];
  const sectionData: TScopesType = {};
  Object.entries(sectionState).forEach(([key, value]) => {
    if (!excludseEdited.includes(key) && value !== undefined) {
      sectionData[key] = value;
    }
  });

  return sectionData;
};

export const serializeEditedProject = (projectState: TScopesType) => {
  const excludseEdited = ["contractName", "show"];
  const projectData: TScopesType = {};
  Object.entries(projectState).forEach(([key, value]) => {
    if (!excludseEdited.includes(key) && value !== undefined) {
      projectData[key] = value;
    } else if (key === "contractName") {
      projectData.contractID = value;
    }
  });

  return projectData;
};
